export const customsDeclarations = {
  title: 'Tờ khai hải quan',
  resourceName: 'Tờ khai hải quan',
  titles: {
    list: 'Danh sách tờ khai hải quan',
    detail: 'Chi tiết tờ khai hải quan',
    create: 'Thêm tờ khai hải quan',
    edit: 'Sửa tờ khai hải quan',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    linkage: 'Lô hàng & HS',
    product: 'Hàng hóa & kỹ thuật',
    origin: 'Xuất xứ & sản xuất',
    commercial: 'Số lượng & giá',
    tax: 'Thuế',
    note: 'Ghi chú',
    audit: 'Hệ thống',
  },
  filter: {
    all: 'Tất cả lô hàng',
  },
  hints: {
    imageLines: 'Mỗi dòng hoặc cách nhau bởi dấu phẩy',
  },
  fields: {
    loHang: 'Lô hàng',
    maHs: 'Mã HS',
    trongLuong: 'Trọng lượng (kg)',
    tenYeuCauXuatHoaDon: 'Tên yêu cầu xuất HĐ',
    tenThuongHieu: 'Thương hiệu',
    model: 'Model',
    moTaSanPham: 'Mô tả sản phẩm',
    hinhAnhSanPham: 'Hình ảnh sản phẩm',
    linkSanPham: 'Link sản phẩm',
    thongSoKyThuat: 'Thông số kỹ thuật',
    kichThuoc: 'Kích thước',
    chieuDai: 'Chiều dài',
    chieuRong: 'Chiều rộng',
    chieuCao: 'Chiều cao',
    theTich: 'Thể tích',
    congSuat: 'Công suất',
    nhaSanXuat: 'Nhà sản xuất',
    diaChiNhaMay: 'Địa chỉ nhà máy',
    nuocXuatXu: 'Nước xuất xứ',
    soLuong: 'Số lượng',
    donVi: 'Đơn vị',
    donGia: 'Đơn giá',
    thanhTien: 'Thành tiền',
    loaiTienTe: 'Loại tiền tệ',
    thueVat: 'Thuế VAT (%)',
    soTienThue: 'Số tiền thuế',
    ghiChu: 'Ghi chú',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  messages: {
    noData: 'Chưa có tờ khai hải quan',
    exportSuccess: 'Xuất Excel tờ khai hải quan thành công',
    exportFailed: 'Xuất Excel tờ khai hải quan thất bại',
  },
}
